import classNames from 'classnames';
import { Button, Heading } from 'yoso';
import { BaseCard } from '~/components/Card';
import heroStyles from '~/components/Hero/Hero.module.scss';
import { T } from '~/components/I18n';
import { useLevelStatuses } from '~/components/Level/Status/LevelStatus.hooks';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { Link, LinkProps } from '~/components/Route/Link';
import styles from './LevelUpHero.module.scss';

export type LevelUpHeroProps = {
  className?: string;
};
export const LevelUpHero = ({ className }: LevelUpHeroProps) => {
  const { data: statuses, isFetched, isLoading } = useLevelStatuses();
  const upAvailableLevels = statuses.filter(({ canLevelUp }) => canLevelUp) || {};
  const upAvailableCount = upAvailableLevels.length;

  return (
    <BaseCard
      className={classNames(
        heroStyles.root,
        styles.root,
        { [styles.loading]: isLoading },
        className
      )}
      size="large">
      <Heading level={3} className={heroStyles.heading}>
        <T name="citizen_levelup_title" />
      </Heading>
      <DescriptionList
        className={classNames(heroStyles.sublist, styles.sublist)}
        layout="horizontal">
        <dt>
          <T name="citizen_levelup_desc" />
        </dt>
        <dd>{upAvailableCount}</dd>
      </DescriptionList>
      <Button<LinkProps>
        className={classNames(heroStyles.button, styles.button)}
        as={Link}
        to="#levelUp"
        size="large"
        replace
        data-event="click"
        data-event-target="levelup_btn_in_main">
        <T name="citizen_levelup_btn" />
      </Button>
    </BaseCard>
  );
};
